import * as React from 'react';
import { useContext, useEffect } from 'react';
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from 'react-router-dom';

import Layout from './layout/Layout';
import Login from './login/Login';
import SiteList from './sites/SiteList';
import StorageList from './storages/StorageList';
import { AuthContext } from './store/authContext';
import UserList from './users/UserList';
import ProductList from './products/ProductList';
import ProductgroupList from './productgroups/ProductgroupList';
import ContactList from './contacts/ContactList';
import ApplicationLinksList from './ApplicationLinks/ApplicationLinksList';
import ReportListPage from './reports/ReportListPage';
import DashboardPage from './dashboard/DashboardPage';

const VPTApp: React.FC = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const history = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    if (isLoggedIn === false && pathname !== '/login') {
      history('/login');
    }
  }, [isLoggedIn, history, pathname]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/sites" element={<SiteList />} />
        <Route path="/storages" element={<StorageList />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/productgroups" element={<ProductgroupList />} />
        <Route path="/contacts" element={<ContactList />} />
        <Route path="/applicationlinks" element={<ApplicationLinksList />} />
        <Route path="/reports" element={<ReportListPage />} />
        <Route path="*" element={<Navigate to="/users" replace />} />
      </Routes>
    </Layout>
  );
};

export default VPTApp;
